<template>
<div>
  <div class="car" :style="'background:'+schema.car.bgColor +';box-shadow: 0 0 2px 4px '+schema.car.bgColor +'; color:'+ schema.car.color +';'">
    <span class="car-province">{{ schema.car.province }}</span>
    <span>{{ schema.car.az }}</span>
    <span class="car-dot">•</span>
    <span>{{ schema.car.number }}</span>
  </div>
  <div class="car-tips" :style="'color:'+ schema.tips.color +'; font-size:'+ schema.tips.fontSize +'px;'">
    {{ schema.tips.text }}
  </div>

  <van-cell-group v-if="schema.isWechat && schema.wechat.length>0">
    <van-cell title="车主微信" label="扫码联系我" icon="wechat" @click="actionPlugin('wechat',0)" is-link/>
  </van-cell-group>
  <van-cell-group v-if="schema.isTel">
    <van-cell 
    v-for="(item, idx) in schema.cells" :key="idx" 
    :title="item.text" :label="item.tel +' '+ item.label" icon="phone"  @click="actionPlugin('cells',idx)" is-link/>
  </van-cell-group>


   <van-dialog v-model="showWechatQr" title="扫一扫加好友" :show-confirm-button="false" close-on-click-overlay>
    <div style="text-align: center;padding:10px;"><img :src="wechatQr" style="max-width: 90%;"/></div>
    <div class="van-hairline--top van-dialog__footer">
      <button @click="showWechatQr=false" type="button" class="van-button van-button--default van-button--large van-dialog__confirm"><div class="van-button__content"><span class="van-button__text">确认</span></div></button>
    </div>
  </van-dialog>
</div>
</template>

<script>
export default {
  name: 'nuoChe',
  props: {
    schema: {
      'type':Object,
      default:{},
      required:true
    },
    pluginIndex:{
      type:Number,
      default:0
    }
  },
  data:function(){
    return {
      showWechatQr:false,
      wechatQr:''
    }
  },
  methods:{
    actionPlugin(field,itemIndex){


      let pluginData =this.$store.state.pluginList[this.pluginIndex] || null
      // console.log('actionPlugin',pluginData);
      
      // var pluginName = pluginData.name;
      if(pluginData && field && itemIndex!==undefined){
          pluginData = pluginData[field][itemIndex]
      }

      if(!pluginData){
          return ;
      }

      //    console.log(field,pluginData);
      if(field=="wechat"){
          if(pluginData.url==''){
              console.log('url empty')
              return ;
          }
          this.showWechatQr = true;
          this.wechatQr = pluginData.url;
      }else{
          if(pluginData.tel==''){
              console.log('tel empty')
              return ;
          }
          //tel
          location.href="tel://"+pluginData.tel;
      }
      
      // this.$store.commit('actionPlugin',{
      //   pluginIndex:this.pluginIndex,
      //   field,
      //   itemIndex
      // })
    }
  }
}
</script>

<style>
.car{
  color: white;
  background-color: #4b5cc4; 
  border-radius: 6px;
  border:white 1px solid;
  text-align: center;
  padding: 10px 0px;
  box-shadow: 0 0 2px 4px #4b5cc4;
  width:90%;
  margin:15px auto;
  font-size: 40px;
  letter-spacing:5px;
  text-transform:uppercase;
}
.car-dot{
  font-size: 28px;
}

.car-tips{
  margin-bottom: 15px;
  text-align: center;
  font-size: 30px;
}
</style>